'use client'

import Subtitle from 'componentsUnits/subtitle';
import { NextPage } from 'next'
import { isDev } from 'app/general';
import { useEffect, useState } from 'react';
import { Props } from 'react-burger-menu';
import { Type } from 'types/type';

const BrowserConnection: NextPage<Props> = ({ children }) => {
    const [isOnline, setIsOnline] = useState(true);
    useEffect(() => {
        function onlineHandler() {
            setIsOnline(true);
        }
        function offlineHandler() {
            setIsOnline(false);
        }
        if (typeof window !== 'undefined') {
            window.addEventListener("online", onlineHandler);
            window.addEventListener("offline", offlineHandler);
        }

        return () => {
            if (typeof window !== 'undefined') {
                window.removeEventListener("online", onlineHandler);
                window.removeEventListener("offline", offlineHandler);
            }
        };
    }, []);

    return (
        <>
            {isOnline
                ? <></>
                : <div style={{ position: "fixed", top: 40, left: 20, zIndex: 999999999 }}>
                    <Subtitle text='You are offline!' type={Type.primary} />
                </div>}
            {children}
        </>
    )
}
export default BrowserConnection;